// extracted by mini-css-extract-plugin
module.exports = {"documentTypeCard":"styles_documentTypeCard__Jjkug","content":"styles_content__2Y1U0","orderInformation":"styles_orderInformation__ue89s"};